<template>
  <div>
    <div class="modal_bg" @click="hideModal" v-if="successShow"></div>
    <div class="modal_body success_modal" v-if="successShow">
      <img src="@/assets/zhengxin_modal_success.jpg" alt="提交成功">
      <p>提交成功</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Success",
  data(){
    return{
      successShow:false
    }
  },
  methods:{
    showModal(){
      this.successShow = true
    },
    hideModal(){
      this.successShow = false
    }
  }
};
</script>

<style scoped lang="less">
  .success_modal{
    width: 182px;
    height: 209px;
    background: #FFFFFF;
    border-radius: 4px;
    box-sizing: border-box;
    overflow: hidden;
    padding: 20px;
    img{
      width: 100%;
    }
    p{
      text-align: center;
      font-size: 22px;
      color: #005293;
      font-weight: bold;
    }
  }
</style>
